import { StreamType } from '../enums';

export * from './socket';
export * from './game';
export * from './market';
export * from './odds';
export * from './bots';
export * from './trading';
export * from './referral';
export * from './country';
export * from './achievements';
export * from './probability-share-text.constants';
export * from './consent';
export * from './newsfeed.constants';

export const otpResendTimeout = '30sec';

export const streamTypes = Object.values(StreamType);
